import React from 'react';
import { string, bool, func } from 'prop-types';
import { withTheme } from 'styled-components';
import { Route, Switch, withRouter } from 'react-router-dom';
import Media from 'react-media';
import { Flex, Box } from 'grid-styled';
import Toolbar from 'material-ui/Toolbar';
import { Strong } from '../Text';

import DataExportDialog from '../DataExport';
import FilteredCrimeCount, { TotalCrimeCount } from '../CrimeCount';
import BackToUS from './BackToUS';

const DividerY = Box.extend.attrs({ flex: 'none', mx: '16px' })`
  width: 1px;
  height: 24px;
  background: ${({ theme }) => theme.colors.grey300};
`;

const DividerX = Box.extend.attrs({ flex: 'none', my: '8px' })`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.grey300};
`;

const TextBox = Box.extend`
  font-size: 15px;
  font-weight: 400;
  margin-right: 15px;
  overflow: hidden;
`;

const BarLink = Strong.extend`
  font-size: 15px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gold500};
`;

const TitleBar = ({
  theme,

  isExportDialogOpen,
  openExportDialog,
  closeExportDialog,

  isDataSettingsDialogOpened,
  openDataSettingsDialog,

  location,
  match: { params },
  ...rest
}) => (
  <Route
    render={({ location: { pathname } }) => (
      <Toolbar style={{ height: 'auto' }}>
        <Media query={theme.media.mobile}>
          {mobile => {
            return (
              <Flex
                className=""
                my="10px"
                style={{
                  minWidth: 0,
                  margin: 'auto',
                  fontWeight: 300,
                  padding: '6px 4px 5px',
                  flexDirection: mobile ? 'column' : 'row',
                }}
              >
                <Route
                  path="/(map|chart|table)/:cityId"
                  render={props => (
                    <React.Fragment>
                      <Box flex="none">
                        <BackToUS {...props} />
                      </Box>
                      {mobile ? <DividerX /> : <DividerY mt="2px" />}
                    </React.Fragment>
                  )}
                />
                <TextBox flex="auto">
                  <span style={{ fontWeight: 300 }}>Showing: </span>
                  <Switch>
                    <Route
                      path="/(table|map)/:cityId"
                      component={FilteredCrimeCount}
                    />
                    <Route
                      path="/(chart|table)"
                      component={FilteredCrimeCount}
                    />
                    <Route path="/map" component={TotalCrimeCount} />
                  </Switch>
                  <span style={{ paddingLeft: '15px' }}>
                    <span className="mobileChangeWrap">
                      <BarLink onClick={openDataSettingsDialog}>
                        &nbsp; Change
                      </BarLink>
                      &nbsp; |
                    </span>
                    <BarLink onClick={e => openExportDialog(pathname, e)}>
                      &nbsp; Export
                    </BarLink>
                  </span>
                </TextBox>
              </Flex>
            );
          }}
        </Media>

        <DataExportDialog
          open={isExportDialogOpen}
          doClose={closeExportDialog}
        />
      </Toolbar>
    )}
  />
);

TitleBar.propTypes = {
  cityId: string,
  isExportDialogOpen: bool.isRequired,
  openExportDialog: func.isRequired,
  closeExportDialog: func.isRequired,
  isDataSettingsDialogOpened: bool.isRequired,
  openDataSettingsDialog: func.isRequired,
};

export default withTheme(withRouter(TitleBar));



// WEBPACK FOOTER //
// ./src/components/TitleBar/TitleBar.jsx